<template>
  <div class="t-select-container">
    <slot name="control">
      <div class="t-select-header">
        <div class="select-header-left" @click="cancel()">{{control.left}}</div>
        <div class="select-header-title">{{control.title}}</div>
        <div class="select-header-right" @click="ok()">{{control.right}}</div>
      </div>
    </slot>
    <div class="t-select-box">
      <slot></slot>
    </div>
  </div>
</template>
<script>
/**
   * @param cancel [Function] 取消触发事件
   * @param ok [Function] 确定触发事件
   * @describe 需要配合tSelectitem组件一起使用
   *
   * @example
   *
    详细见tSelectitem组件
   */
export default {
  name: 'tSelectbox',
  props: {
    control: {
      type: Object,
      default () {
        return {
          left: '取消',
          title: '',
          right: '确定',
        };
      },
    },
  },
  methods: {
    cancel: function () {
      if (this.$children && Array.isArray(this.$children)) {
        this.$children.forEach((t) => {
          t.init && t.init();
        });
      }
      this.$emit('cancel');
    },
    ok: function () {
      if (this.$children && Array.isArray(this.$children)) {
        this.$children.forEach((t) => {
          t.updateValue && t.updateValue();
        });
      }
      this.$emit('ok');
    },
  },
};

</script>
<style lang="scss">
@import "../style/mixin";
.t-select-header {
  display: flex;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  background-color: #fbf9fe;
  @include border-1px-b(#C7C7C7);
  .select-header-left {
    padding-left: 15px;
    color: #828282;
  }
  .select-header-title {
    flex: 1;
    text-align: center;
    color: #222;
  }
  .select-header-right {
    padding-right: 15px;
    color: #FF9900;
  }
}

.t-select-box {
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/selectbox.vue